import { Logtail } from '@logtail/browser'
export const logtail =
  window && ENV.LOGTAIL_SOURCE_TOKEN
    ? new Logtail(ENV.LOGTAIL_SOURCE_TOKEN, {
        sendLogsToBetterStack: true,
        sendLogsToConsoleOutput: true,
      })
    : null
